{
  "zh-TW": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      },
      "confirm": {
        "question": "確定嗎？",
        "yes": "是",
        "no": "否"
      }
    }
  }
}
